import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  html {
    height: 100%;
    margin: 0;
    padding: 0;
  }

  body {
    height: 100%;
    margin: 0;
    padding: 0;
  }

  #root {
    height: 100vh;
    width: 100vw;
    overflow: unset;
    font-display: swap;
  }

  /*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */
  /* Document
     ========================================================================== */

  /**
   * 1. Correct the line height in all browsers.
   * 2. Prevent adjustments of font size after orientation changes in iOS.
   */

  html {
    line-height: 1.15; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
  }

  /* Sections
     ========================================================================== */

  /**
   * Remove the margin in all browsers.
   */

  body {
    margin: 0;
  }

  /**
   * Correct the font size and margin on 'h1' elements within 'section' and
   * 'article' contexts in Chrome, Firefox, and Safari.
   */

  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  /* Grouping content
     ========================================================================== */

  /**
   * 1. Add the correct box sizing in Firefox.
   * 2. Show the overflow in Edge and IE.
   */

  hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
  }

  /**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd 'em' font sizing in all browsers.
   */

  pre {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /* Text-level semantics
     ========================================================================== */

  /**
   * Remove the gray background on active links in IE 10.
   */

  a {
    background: transparent;
  }

  /**
   * 1. Remove the bottom border in Chrome 57-
   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
   */

  abbr[title] {
    border-bottom: none; /* 1 */
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
  }

  /**
   * Add the correct font weight in Chrome, Edge, and Safari.
   */

  b,
  strong {
    font-weight: bolder;
  }

  /**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd 'em' font sizing in all browsers.
   */

  code,
  kbd,
  samp {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /**
   * Add the correct font size in all browsers.
   */

  small {
    font-size: 80%;
  }

  /**
   * Prevent 'sub' and 'sup' elements from affecting the line height in
   * all browsers.
   */

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  /* Embedded content
     ========================================================================== */

  /**
   * Remove the border on images inside links in IE 10.
   */

  img {
    border-style: none;
  }

  /* Forms
     ========================================================================== */

  /**
   * 1. Change the font styles in all browsers.
   * 2. Remove the margin in Firefox and Safari.
   */

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
  }

  /**
   * Show the overflow in IE.
   * 1. Show the overflow in Edge.
   */

  button,
  input {
    /* 1 */
    outline: none;
    border: none;
    overflow: visible;
  }

  /**
   * Remove the inheritance of text transform in Edge, Firefox, and IE.
   * 1. Remove the inheritance of text transform in Firefox.
   */

  button,
  select {
    /* 1 */
    text-transform: none;
  }

  /**
   * Correct the inability to style clickable types in iOS and Safari.
   */

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }

  /**
   * Remove the inner border and padding in Firefox.
   */

  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  /**
   * Restore the focus styles unset by the previous rule.
   */

  button:-moz-focusring,
  [type='button']:-moz-focusring,
  [type='reset']:-moz-focusring,
  [type='submit']:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  /**
   * Correct the padding in Firefox.
   */

  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  /**
   * 1. Correct the text wrapping in Edge and IE.
   * 2. Correct the color inheritance from 'fieldset' elements in IE.
   * 3. Remove the padding so developers are not caught out when they zero out
   *    'fieldset' elements in all browsers.
   */

  legend {
    box-sizing: border-box; /* 1 */
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
  }

  /**
   * Add the correct vertical alignment in Chrome, Firefox, and Opera.
   */

  progress {
    vertical-align: baseline;
  }

  /**
   * Remove the default vertical scrollbar in IE 10+.
   */

  textarea {
    overflow: auto;
  }

  /**
   * 1. Add the correct box sizing in IE 10.
   * 2. Remove the padding in IE 10.
   */

  [type='checkbox'],
  [type='radio'] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
  }

  /**
   * Correct the cursor style of increment and decrement buttons in Chrome.
   */

  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }

  /**
   * 1. Correct the odd appearance in Chrome and Safari.
   * 2. Correct the outline style in Safari.
   */

  [type='search'] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }

  /**
   * Remove the inner padding in Chrome and Safari on macOS.
   */

  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  /**
   * 1. Correct the inability to style clickable types in iOS and Safari.
   * 2. Change font properties to 'inherit' in Safari.
   */

  &::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }

  /* Interactive
     ========================================================================== */

  /*
   * Add the correct display in Edge, IE 10+, and Firefox.
   */

  details {
    display: block;
  }

  /*
   * Add the correct display in all browsers.
   */

  summary {
    display: list-item;
  }

  /* Misc
     ========================================================================== */

  /**
   * Add the correct display in IE 10+.
   */

  template {
    display: none;
  }

  /**
   * Add the correct display in IE 10.
   */

  [hidden] {
    display: none;
  }

  /* End of normalize.css */

  * {
    font-family: 'Poppins', Arial, sans-serif;
    box-sizing: border-box;
  }

  h1, h2, h3, h4, h5, h6,
  p, span, a, div {
    // &:not(.not-default-text-color) {
    //   color: ${({ theme }) => theme.textColor};
    // }
    color: ${({ theme }) => theme.textColor}
  }

  h4 {
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
  }

  h5 {
      display: block;
      font-size: 0.83em;
      margin-block-start: 1.67em;
      margin-block-end: 1.67em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      font-weight: bold;
  }

  input[type='file'] {
    display: none;
  }

  /* react-dates stylings */
  .DayPickerNavigation_button {
    box-sizing: content-box;
    display: inline-block;
    cursor: pointer;
    min-width: initial;
    outline: none;
    background: transparent;
    color: ${({ theme }) => theme.dates.text};
    transition: all 0.1s ease-in-out;
  }

  .DayPickerNavigation_button > svg {
    margin-right: 0;
  }

  .DayPickerNavigation_button:hover {
    background: transparent;
    color: ${({ theme }) => theme.dates.textHover};
  }

  .DateInput {
    min-width: 180px;
    @media (max-width: 1023px) {
      min-width: auto;
    }
  }

  .DateInput_input {
    display: block;
    width: 100%;
    padding: 0.75rem 0.5rem;
    border: 1px solid ${({ theme }) => theme.dates.inputBorder};
    color: ${({ theme }) => theme.textColor};
    font-size: 14px;
    transition: all 0.1s ease-in-out;

    font-weight: 400;
    height: 50px;
  }

  .DateInput__disabled {
    background: transparent;
  }

  .SingleDatePickerInput {
    border: none;
  }

  .SingleDatePickerInput__disabled {
    cursor: not-allowed;
    background: transparent;
  }

  .CalendarDay__highlighted_calendar {
    background: ${({ theme }) => theme.dates.cell}var(--color-dark);
    color: ${({ theme }) => theme.dates.text};
  }

  .CalendarDay__highlighted_calendar:hover {
    background: ${({ theme }) => theme.dates.cellHover};
    color: ${({ theme }) => theme.dates.textHover};
  }

  .DayPicker button {
    background: transparent;
  }

  .DayPickerKeyboardShortcuts_show__bottomRight {
    border-right: 33px solid ${({ theme }) => theme.primary};
  }

  .DayPickerKeyboardShortcuts_show__bottomRight:hover {
    border-right: 33px solid ${({ theme }) => theme.primaryHover};
  }

  /* end of react-dates stylings */

  /* react-toast stylings */
  .toast {
    font-family: 'Poppins', sans-serif;
    z-index: 10000;
    margin-right: 200px;
    width: 350px;
  }

  .Toastify__toast-container--top-right {
    left: unset;
    right: 4em;
    @media (max-width: 1023px) {
      right: 0;
    }
  }

  .toast-body {
    color: ${({ theme }) => theme.toast.text};
    font-size: 14px;
    line-height: 20px;
    align-items: flex-start !important;
  }

  .toast.Toastify__toast--success {
    background: ${({ theme }) => theme.toast.success};
  }

  .toast.Toastify__toast--info {
    background: ${({ theme }) => theme.toast.info};
  }

  .toast.Toastify__toast--error {
    background: ${({ theme }) => theme.toast.error};
  }

  .toast.Toastify__toast--error > div > div > div {
    color: #ffffff;
  }

  .toast.Toastify__toast--error > .toast-body > .Toastify__toast-icon > svg {
    fill: #ffffff;
  }

  .toast.Toastify__toast--error > .Toastify__close-button > svg {
    fill: #ffffff;
  }

  .toast button {
    box-sizing: content-box;
    display: inline-block;
    cursor: pointer;
    min-width: initial;
    border: none;
    outline: none;
    background: transparent;
    color: ${({ theme }) => theme.toast.close};
    transition: all 0.1s ease-in-out;
  }

  .toast button:hover {
    background: transparent;
    color: ${({ theme }) => theme.toast.textHover};
  }

  #toast-message-container {
    .Toastify__toast-container {
      width: 100%;
      top: 0;
      right: 0;
      z-index: 10000;

      @media (min-width: 425px) {
        max-width: 380px;
        top: 1em;
        right: 1em;
      }
    }

    .toast-message {
      padding: 16px;
      min-height: unset;
    }

    .toast-message-body {
      padding: 0;
      margin: 0;
      align-items: start;
    }

    .toast-message {

      .Toastify__toast-icon {
        align-self: start;
      }

      div {
        display: flex;
        align-self: stretch;
        align-items: center;

        font-size: 0.875rem;
        font-weight: 600;
        line-height: 1.1875rem;
      }

      .Toastify__close-button--light {
        opacity: 1;
        width: 24px;
        height: 24px;
        padding: 4px;
        margin-left: 4px;
      }

    }

    .toast-message.Toastify__toast {
      .Toastify__toast-icon {
        width: 24px;
        padding: 4px;
        margin-inline-end: 4px;
      }
    }

    .toast-message.Toastify__toast--success {
      background: ${({ theme }) => theme.toast.success};

      .Toastify__toast-icon {
        svg {
          fill: #56C768;
        }
      }

      div {
        color: #25282B;
      }

      .Toastify__close-button--light {
        color: #25282B;
      }
    }

    .toast-message.Toastify__toast--error {
      background: ${({ theme }) => theme.toast.error};

      .Toastify__toast-icon {
        width: 24px;
        padding: 4px;
        margin-inline-end: 4px;

        svg {
          fill: ${({ theme }) => theme.toast.text};
        }
      }

      div {
        color: #FFFFFF;
      }

      .Toastify__close-button--light {
        color: ${({ theme }) => theme.toast.text};
      }
    }
  }

  /* end of react-toast stylings */

  /* styling for Freshchat position */
  #fc_frame {
    bottom: 60px !important;
    right: 8px !important;
    
    @media (min-width: 992px) {
      bottom: 4px !important;
    }
  }

  @media all and (min-width: 768px) {
    /* removes excess white space at bottom of page in Tablet */
    main {
      min-height: calc(100vh - 80px);
    }
  }

  .line-clamp {
    display: -webkit-box;
    -webkit-box-orient: vertical;  
    overflow: hidden;
  }

  .line-clamp-2 {
     -webkit-line-clamp: 2;
  }

  .lms-course-syllabus-catalog .swiper-pagination-bullet-active {
    background: ${({ theme }) => theme.buttonsColor.swiper.active};
  }

  .lms-course-syllabus-catalog .swiper-slide {
    &.swiper-slide-active {
      .tile-container {
        margin-left: 10px !important;
      }   
    }

    .tile-container {
      margin-right: 2px !important;
    }
  }

  @media screen and (max-width: 562px) {
    .lms-course-syllabus-catalog .swiper-slide {
      width: 100% !important;

      .tile-container {
        margin-right: 10px !important;
      }
    }
  }
  .rpv-full-screen__overlay {
    display: none !important;
  }
`;
